import React, { useEffect, useRef } from "react";
import { Container, Typography } from "@mui/material";
import "./Carousel1.css";

// Import all service images
import krinvyservice11 from "../assets/images/Krinvy_angularjs.png";
import krinvyservice12 from "../assets/images/Krinvy_bootstrap.png";
import krinvyservice13 from "../assets/images/Krinvy_css.png";
import krinvyservice14 from "../assets/images/Krinvy_expressjs.png";
import krinvyservice15 from "../assets/images/Krinvy_github.png";
import krinvyservice16 from "../assets/images/Krinvy_googleanalytics.png";
import krinvyservice17 from "../assets/images/Krinvy_googlecloud.png";
import krinvyservice18 from "../assets/images/Krinvy_html.png";
import krinvyservice19 from "../assets/images/Krinvy_hubspot.png";
import krinvyservice20 from "../assets/images/Krinvy_javscript.png";
import krinvyservice21 from "../assets/images/Krinvy_mongodb.png";
import krinvyservice22 from "../assets/images/Krinvy_mui.png";
import krinvyservice23 from "../assets/images/Krinvy_mysql.png";
import krinvyservice24 from "../assets/images/Krinvy_nextjs.png";
import krinvyservice25 from "../assets/images/Krinvy_nodejs.png";
import krinvyservice26 from "../assets/images/Krinvy_postgresql.png";
import krinvyservice27 from "../assets/images/Krinvy_reactjs.png";
import krinvyservice28 from "../assets/images/Krinvy_redux.png";
import krinvyservice29 from "../assets/images/Krinvy_sql.png";
import krinvyservice30 from "../assets/images/Krinvy_tailwindcss.png";
import krinvyservice31 from "../assets/images/Krinvy_typescript.png";
import krinvyservice32 from "../assets/images/Krinvy_vite.png";
import krinvyservice33 from "../assets/images/Krinvy_vscode.png";
import krinvyservice34 from "../assets/images/Krinvy_vue.png";
import krinvyservice35 from "../assets/images/Krinvy_wordpress.png";
import krinvyservice36 from "../assets/images/three.js.png";

const images = [
    krinvyservice11, krinvyservice12, krinvyservice13,
    krinvyservice14, krinvyservice15, krinvyservice16,
    krinvyservice17, krinvyservice18, krinvyservice19,
    krinvyservice20, krinvyservice21, krinvyservice22,
    krinvyservice23, krinvyservice24, krinvyservice25,
    krinvyservice26, krinvyservice27, krinvyservice28,
    krinvyservice29, krinvyservice30, krinvyservice31,
    krinvyservice32, krinvyservice33, krinvyservice34,
    krinvyservice35, krinvyservice36
];

const Carousel1 = () => {
    const trackRef = useRef(null);
    
    useEffect(() => {
        const track = trackRef.current;
        let animationFrameId;
        
        const animate = () => {
            if (track) {
                // Get current transform value
                const currentTransform = window.getComputedStyle(track).getPropertyValue('transform');
                const matrix = new DOMMatrix(currentTransform);
                const currentX = matrix.m41;
                
                // Reset position when we've scrolled one set of images
                if (currentX >= 0) {
                    track.style.transform = `translateX(-${track.scrollWidth / 2}px)`;
                } else {
                    // Move 1 pixel to the right
                    track.style.transform = `translateX(${currentX + 1}px)`;
                }
            }
            animationFrameId = requestAnimationFrame(animate);
        };
        
        // Start animation
        animationFrameId = requestAnimationFrame(animate);
        
        // Clean up
        return () => {
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <Container className="carousel1-section" maxWidth="lg">
            <Typography variant="h5" align="center" className="carousel1-heading" data-aos="fade-up">
                Web Development 
            </Typography>

            <div className="carousel1-slider">
                <div className="carousel1-track" ref={trackRef}>
                    {images.map((img, index) => (
                        <div className="carousel1-slide" key={`first-${index}`}>
                            <img 
                                src={img} 
                                height="150" 
                                width="150" 
                                alt={`Web Development Service ${index + 11}`} 
                            />
                        </div>
                    ))}
                    {images.map((img, index) => (
                        <div className="carousel1-slide" key={`second-${index}`}>
                            <img 
                                src={img} 
                                height="150" 
                                width="150" 
                                alt={`Web Development Service ${index + 11}`} 
                            />
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
};

export default Carousel1;